import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mediator, { ACTIONS } from 'mediator';
import metrics from 'lib/common/metrics';
import getAvailablePrices from 'lib/pricing/getAvailablePrices';
import { toCurrency } from 'lib/common/displayHelpers';
import { getColorCode } from 'lib/common/colorCode';

class PriceKey extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPrice: '',
      selectedPrices: null,
      pricesToDisplay: getAvailablePrices(this.props.prices)
    };

    this.resetState = this.resetState.bind(this);
    this.resetSelectedPrices = this.resetSelectedPrices.bind(this);
    this.filterByLevel = this.filterByLevel.bind(this);
    this.filterByZones = this.filterByZones.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getPriceDisplayText = this.getPriceDisplayText.bind(this);
    this.getPriceValue = this.getPriceValue.bind(this);
  }

  componentWillMount() {
    mediator.subscribe(ACTIONS.LEVEL_SELECTED, this.filterByLevel);
    mediator.subscribe(ACTIONS.SCREEN_FILTER_SELECTED, this.filterByZones);
  }

  componentDidUpdate() {
    let selectedPrices = this.state.selectedPrices;
    if (Array.isArray(selectedPrices) && selectedPrices !== null) {
      let priceTypeZones = selectedPrices.map(x => parseInt(x.zone_no, 10));

      mediator.publish(ACTIONS.PRICE_FILTER_SELECTED, {
        selected: priceTypeZones
      });
    }
  }

  componentWillUnmount() {
    mediator.unsubscribe(ACTIONS.LEVEL_SELECTED, this.filterByLevel);
    mediator.unsubscribe(ACTIONS.SCREEN_FILTER_SELECTED, this.filterByZones);
  }

  resetState() {
    metrics.action('Filtered prices', 'Any price');
    this.setState({
      selectedPrice: '',
      selectedPrices: []
    });
  }

  resetSelectedPrices() {
    this.setState({
      pricesToDisplay: getAvailablePrices(this.props.prices)
    });
  }

  filterByLevel(selectedLevel) {
    let { prices, zonesByLevel } = this.props;
    let zonesForSelectedLevel = zonesByLevel && zonesByLevel[selectedLevel];
    if (zonesForSelectedLevel) {
      this.setState({
        selectedPrices: null,
        pricesToDisplay: getAvailablePrices(prices, zonesForSelectedLevel)
      });
    } else {
      this.resetSelectedPrices();
    }
  }

  filterByZones(data) {
    let { prices, screenZoneData } = this.props;
    if (data && screenZoneData) {
      let selectedZones = screenZoneData[data.selected].zones;
      this.setState({
        pricesToDisplay: getAvailablePrices(prices, selectedZones)
      });
    } else {
      this.resetSelectedPrices();
    }
  }

  getPriceDisplayText(price) {
    return toCurrency(price.priceData.price);
  }

  /**
   * @param  Object price
   * @return string
   */
  getPriceValue(price) {
    return price.priceData.price;
  }

  getZoneGroupName(price) {
    return price.priceData.zone_group_desc
  }

  onChange(e) {
    const val = e.target.value;
    if (val) {
      let valArray = val.split('-');
      let prices;

      // ensure that the selected price is a box price or not before filtering
      if (valArray[1]) {
        prices = this.props.prices.filter(x => {
          return x.price === parseFloat(valArray[0]) && x.price_type === valArray[1];
        });
      } else {
        prices = this.props.prices.filter(x => {
          return x.price === parseFloat(val);
        });
      }

      metrics.action('Filtered prices', toCurrency(valArray[0]));

      this.setState({
        selectedPrice: valArray[1]
          ? `${valArray[0]}-${valArray[1]}`
          : valArray[0],
        selectedPrices: prices
      });
    } else {
      this.resetState();
    }
  }

  render() {
    let pricesToDisplay = this.state.pricesToDisplay;

    pricesToDisplay = pricesToDisplay.map(x => {
      x.priceData.color = getColorCode(x.priceData, this.props.colours);

      return x;
    });

    return (
      <div className="syos-key syos-key--optional syos-price-filter">
        <span className="syos-price-filter__label-text">
          Filter by zone:
        </span>
        <ul className="syos-key__list">
          <li className="syos-key__list__item">
            <input
              type="radio"
              className="syos-key__option-input"
              onChange={this.onChange}
              name="radio-price"
              id="radio-price-all"
              value=""
              checked={this.state.selectedPrice === ''}
            />
            <label className="syos-key__option-label" htmlFor="radio-price-all">
              <div className="any-price-icon" />
              Any zone
            </label>
          </li>
          {pricesToDisplay.map((item, idx) => {
            return (
              <li
                className={`syos-key__list__item${
                  item.isDisabled ? ' disabled' : ''
                }`}
                key={idx}
              >
                <input
                  type="radio"
                  className="syos-key__option-input"
                  onChange={this.onChange}
                  name="radio-price"
                  id={`radio-price-${idx}`}
                  value={this.getPriceValue(item)}
                  checked={
                    parseFloat(this.state.selectedPrice) === this.getPriceValue(item)
                  }
                  disabled={item.isDisabled}
                />
                <label
                  className="syos-key__option-label"
                  htmlFor={`radio-price-${idx}`}
                >
                  <div
                    className="price-icon"
                    style={{ borderColor: item.priceData.color }}
                  />
                  {this.getZoneGroupName(item)}
                </label>
              </li>
            );
          })}
        </ul>
        <div className="syos-price-filter__label-note-text">
          <strong>Note</strong>: Prices are available once you select a seat
        </div>
      </div>
    );
  }
}

PriceKey.defaultProps = {
  prices: []
};

PriceKey.propTypes = {
  prices: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenZoneData: PropTypes.object,
  zonesByLevel: PropTypes.object,
  colours: PropTypes.array
};

export default PriceKey;



// WEBPACK FOOTER //
// ./src/javascripts/components/PriceKey.js